module.exports = __webpack_public_path__ + "img/gift-catalog.13640808.png";